import { supabase } from "../lib/supabase";
import { SupabaseUser, UserResource } from "../types/supabase";
import { BaseApi } from "./baseApi";

type MenteeData = {
  uuid?: string;
  resources?: string[];
  key_insights?: UserResource[];
};

class UserApi extends BaseApi<SupabaseUser> {
  async getById(id: string): Promise<SupabaseUser | null> {
    const { data, error } = await supabase
      .from("vincer_base_user")
      .select(
        `
        uuid,
        name,
        email,
        date_joined,
        user_roles:user_roles (
          role_name
        ),
        mentee:mentee (
          uuid,
          resources,
          key_insights
        )
      `
      )
      .eq("uuid", id)
      .maybeSingle();
    if (error) throw error;
    if (!data) return null;

    // Map user_roles to roles array
    const roles = Array.isArray(data.user_roles)
      ? data.user_roles.map((r: { role_name: string }) => r.role_name)
      : [];

    const mentee = data.mentee as MenteeData | MenteeData[] | null | undefined;
    const menteeObj = Array.isArray(mentee) ? mentee[0] : mentee;

    return {
      uuid: data.uuid,
      name: data.name,
      email: data.email,
      dateJoined: data.date_joined,
      isMentee: roles.includes("MENTEE"),
      roles,
      menteeUuid: menteeObj?.uuid ?? null,
      resources: menteeObj?.resources ?? [],
      keyInsights: menteeObj?.key_insights ?? [],
    };
  }
}

export const userApi = new UserApi("vincer_base_user");
